import {Pipe, PipeTransform} from '@angular/core';
import {ManageInitiative} from '../shared/models/manage-initiative.model';

@Pipe({
  name: 'filterInitiativesList'
})
export class FilterInitiativesListPipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): ManageInitiative[] {
    if (!value || value.length === 0 || args.length === 0 || !args) {
      return;
    }
    let filteredObjects;
    filteredObjects = value.filter(item => {
      return (
        (item.initiativeID.toString().includes(args)) ||
        (item.title && item.title.includes(args)) ||
        (item.host && item.host.includes(args)) ||
        (item.genre && item.genre.includes(args)) ||
        (item.public && item.public.includes(args))
      );
    });
    return filteredObjects;
  }

}
